module.exports = __webpack_public_path__ + "img/blpjs01_center_002.e029cc75.png";